import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { QapaPage } from 'src/types/fam-graphql'

import type { RootState } from '../store'

import { actionTypes } from './types'

// eslint-disable-next-line @typescript-eslint/ban-types
export type QuizzLandingState = {
  qapaPage: QapaPage | null
}

//
// Initial state
//
const initialState: QuizzLandingState = {
  qapaPage: null,
}

//
// Slice (Actions & Reducers)
//
const slice = createSlice({
  name: 'quizzLanding',
  initialState,
  reducers: {
    init: () => undefined,
    setQapaPage: (state, action: actionTypes.setQapaPage) => {
      state.qapaPage = action.payload
    },
  },
  extraReducers: {
    [HYDRATE]: (_state, action) => {
      return action.payload.quizzLanding
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//
const root = (state: RootState) => state.quizzLanding
const qapaPage = (state: RootState) => root(state).qapaPage

export const selectors = {
  qapaPage,
}
